import { Component, Input, OnInit } from '@angular/core';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { Prestation } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-dashboard-messaging',
	templateUrl: './dashboard-messaging.component.html',
	styleUrls: ['./dashboard-messaging.component.scss']
})
export class DashboardMessagingComponent {
	@Input() listNotification: MessageNotification[] = [];
	@Input() listBeneficiaire: Beneficiaire[] = [];
	@Input() listPrestation: Prestation[] = [];
	@Input() manyNewMessages: boolean = false;

	constructor() {}
}
